import {
    ACCEPTJS_UPDATE_CLIENT_TOKEN,
    ACCEPTJS_UPDATE_PAYMENT_METHODS,
    ACCEPTJS_CLEAR_PAYMENT_PROFILE,
    ACCEPTJS_SELECT_PAYMENT_PROFILE,
    ACCEPTJS_PAYMENT_CARD_UPDATE,
    ACCEPTJS_PAYMENT_DATA_UPDATE,
    PURCHASE_ORDER_PAYMENT_DATA_UPDATE,
    SELECT_PAYMENT_OPTION,
    COMPLETE_CHECKOUT,
    NOTIFY_COMPLETE_CHECKOUT_ERROR
} from '../../GlobalStateContainer'

export const PaymentOptions = function (state = [], action) {
    return state;
}

export const SelectedPaymentOptionId = function (state = '', action) {
    switch (action.type) {
        case SELECT_PAYMENT_OPTION:
            return action.paymentMethodId || '';
        case NOTIFY_COMPLETE_CHECKOUT_ERROR:
            return '';
        default:
            return state;
    }
}

export const PaymentRecord = function (state = {}, action) {
    switch (action.type) {
        case ACCEPTJS_UPDATE_CLIENT_TOKEN:
            return Object.assign({}, state, { AcceptJsClientToken: action.payload && action.payload.Token });
        case ACCEPTJS_UPDATE_PAYMENT_METHODS: 
            return Object.assign({}, state, { AcceptJsClientPaymentMethods: action.payload });
        case ACCEPTJS_PAYMENT_CARD_UPDATE:
            return Object.assign({}, state, { AcceptJsCardValues: action.payload });
        case ACCEPTJS_PAYMENT_DATA_UPDATE:
            return Object.assign(
                {},
                state,
                {
                    AcceptJsPaymentPayload: action.payload,
                    AcceptJsPaymentOpaqueData: action.payload && action.payload.opaqueData,
                    PaymentFirstName: action.payload && action.payload.firstName,
                    PaymentLastName: action.payload && action.payload.lastName,
                    AuthorizeDotNetPaymentProfileId: null
                });
        case ACCEPTJS_CLEAR_PAYMENT_PROFILE:
            return Object.assign(
                {},
                state,
                { 
                    AuthorizeDotNetPaymentProfileId : null,
                    AcceptJsPaymentPayload: null,
                    AcceptJsPaymentOpaqueData: null,
                    PaymentFirstName: null,
                    PaymentLastName: null
                });
        case ACCEPTJS_SELECT_PAYMENT_PROFILE:
            return Object.assign(
                {},
                state,
                { 
                    AuthorizeDotNetPaymentProfileId : action.payload,
                    AcceptJsPaymentPayload: null,
                    AcceptJsPaymentOpaqueData: null,
                    PaymentFirstName: null,
                    PaymentLastName: null
                });
        case PURCHASE_ORDER_PAYMENT_DATA_UPDATE:
            return Object.assign({}, state, { POValue: action.number });
        case COMPLETE_CHECKOUT:
            return Object.assign(
                {},
                state,
                {
                    AcceptJsCardValues: {
                        cardNumber: '',
                        cardCode: '',
                        expDate: '',
                        firstName: '',
                        lastName: ''
                    }
                });
        default:
            return state;
    }
}

export const purchaseOrderAvailableCredit = function (state = [], action) {
    return state;
}

export const purchaseOrderStatusOnHold = function (state = [], action) {
    return state;
}